import { client } from '@/client';

export function getLogsList(params) {
  return client.post('/api/audit_log/page-query', params);
}

export function deleteLogs(params) {
  return client.post(`/api/audit_log/delete`, params);
}

export function getOpenapiLogsList(params) {
  return client.post('/openapi/manager/page-query', params);
}

export function deleteOpenapiLogs(params) {
  return client.post(`/openapi/manager/delete`, params);
}
